export const getLastWord = (str: string): string => {
  const lastIndexOfSpace = str.lastIndexOf(' ');

  if (lastIndexOfSpace === -1) {
    return str;
  }

  return str.substring(lastIndexOfSpace + 1, str.length);
};
